import { render, staticRenderFns } from "./BlueBackground.vue?vue&type=template&id=20000225&scoped=true&"
import script from "./BlueBackground.vue?vue&type=script&lang=js&"
export * from "./BlueBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlueBackground.vue?vue&type=style&index=0&id=20000225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20000225",
  null
  
)

export default component.exports